import {LoginType} from '../../types/login/login.type';

export const LOGIN_TYPE = {
    NONE: 'None',
    USERNAME: 'Username',
    WINDOWS: 'Windows',
    AZURE: 'Azure'
} as const satisfies Record<string, LoginType>;
